import { Stack, Typography } from '@mui/material';

export const MissionEmpty = () => {
    return (
        <Stack justifyContent="center" alignItems="center" gap={3}>
            <img src="./img/not-found.png" alt="No mission found" />
            <Stack gap={0} alignItems="center">
                <Typography variant="h6" fontWeight="bold">
                    No mission found
                </Typography>
                <Typography
                    variant="body2"
                    align="center"
                    color="text.secondary"
                    gutterBottom
                >
                    It seems your mission list is empty.
                </Typography>
            </Stack>
        </Stack>
    );
};
